export interface ProfileCompletionInput {
  first_name?: string;
  last_name?: string;
  location?: string;
  profile_pic?: string;
  bio?: string;
  specializations?: any[];
  phone?: string;
  website?: string;
  experience?: string;
}

export interface ProfileFieldItem {
  id: string;
  name: string;
  isFilled: boolean;
  isRequired: boolean;
}

export const calculateProfileCompletionScore = (data: ProfileCompletionInput): number => {
  const checklist = getProfileFieldsChecklist(data);
  const filled = checklist.filter(item => item.isFilled).length;
  return Math.round((filled / checklist.length) * 100);
};

export const getProfileFieldsChecklist = (data: ProfileCompletionInput): ProfileFieldItem[] => {
  return [
    { id: 'first_name', name: 'First Name', isFilled: !!(data.first_name && data.first_name.trim() !== ''), isRequired: true },
    { id: 'last_name', name: 'Last Name', isFilled: !!(data.last_name && data.last_name.trim() !== ''), isRequired: true },
    { id: 'location', name: 'Location', isFilled: !!(data.location && data.location.trim() !== ''), isRequired: true },
    { id: 'specializations', name: 'Specializations / Skills', isFilled: !!(data.specializations && data.specializations.length > 0), isRequired: true },
    { id: 'phone', name: 'Phone Number', isFilled: !!(data.phone && data.phone.trim() !== ''), isRequired: true },
    { id: 'bio', name: 'Bio / About You', isFilled: !!(data.bio && data.bio.trim() !== ''), isRequired: false },
    { id: 'experience', name: 'Experience Level', isFilled: !!(data.experience && data.experience.trim() !== ''), isRequired: false },
    { id: 'website', name: 'Website Link', isFilled: !!(data.website && data.website.trim() !== ''), isRequired: false },
  ];
};

export const hasCompletedRequiredProfile = (data: ProfileCompletionInput): boolean => {
  const checklist = getProfileFieldsChecklist(data);
  return checklist.every(item => !item.isRequired || item.isFilled);
};


